import {
  getHasChangedPhotoOrder,
  getIsPhotoPersisted,
  getPhotoFileId,
  getUnpersistedPhotos,
} from '../../RentalPortalPhotoGallery'

export function getHasListingPhotoUploadsInProgress(uploadingFiles) {
  return uploadingFiles.length > 0
}

export function getHasAbandonedListingPhotoUploads({ photos, uploadingFiles }) {
  return (
    getHasListingPhotoUploadsInProgress(uploadingFiles) ||
    getUnpersistedPhotos(photos).length > 0
  )
}

export function getHasUnsavedListingPhotoChanges({
  initialPhotos,
  photos,
  uploadingFiles,
}) {
  return (
    getHasAbandonedListingPhotoUploads({ photos, uploadingFiles }) ||
    getHasChangedPhotoOrder({ initialPhotos, photos })
  )
}

export function getListingPhotosWithoutFile(photos, fileId) {
  return photos.filter(photo => getPhotoFileId(photo) !== fileId)
}

export function getHasRemovedPersistedListingPhoto({ nextPhotos, photos }) {
  return photos.some(
    photo =>
      getIsPhotoPersisted(photo) &&
      !nextPhotos.some(
        nextPhoto =>
          getIsPhotoPersisted(nextPhoto) &&
          getPhotoFileId(nextPhoto) === getPhotoFileId(photo)
      )
  )
}
